import { Trees } from 'lucide-react';

interface TreeCalculatorProps {
  areaHectares?: number | string | null;
  rowSpacingMeters?: number | string | null;
  treeSpacingMeters?: number | string | null;
  estimatedCount?: number | string | null;
}

function TreeCalculator({
  areaHectares,
  rowSpacingMeters,
  treeSpacingMeters,
  estimatedCount,
}: TreeCalculatorProps) {
  const area = Number(areaHectares);
  const rowSpacing = Number(rowSpacingMeters);
  const treeSpacing = Number(treeSpacingMeters);
  const parsedEstimatedCount = Number(estimatedCount);

  const hasInputs =
    Number.isFinite(area) && area > 0 &&
    Number.isFinite(rowSpacing) && rowSpacing > 0 &&
    Number.isFinite(treeSpacing) && treeSpacing > 0;

  if (!hasInputs) return null;

  const areaSqM = area * 10000;
  const treeArea = rowSpacing * treeSpacing;
  const theoretical = Math.round(areaSqM / treeArea);
  const final = Number.isFinite(parsedEstimatedCount)
    ? parsedEstimatedCount
    : Math.round(theoretical * 0.9);

  return (
    <div className="bg-success-50 border border-success-200 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        <Trees className="h-4 w-4 text-success-600" />
        <span className="text-sm font-semibold text-success-800">Tree Count Estimate</span>
      </div>
      <div className="space-y-1 text-xs text-success-700">
        <div className="flex justify-between">
          <span>Area:</span>
          <span>{area.toFixed(2)} ha ({areaSqM.toLocaleString()} m²)</span>
        </div>
        <div className="flex justify-between">
          <span>Area per tree ({rowSpacing}m × {treeSpacing}m):</span>
          <span>{treeArea} m²</span>
        </div>
        <div className="flex justify-between">
          <span>Theoretical count:</span>
          <span>{theoretical.toLocaleString()}</span>
        </div>
        <div className="flex justify-between">
          <span>× 90% efficiency:</span>
          <span className="font-bold text-success-900">{final.toLocaleString()} trees</span>
        </div>
      </div>
    </div>
  );
}

export default TreeCalculator;
